import { FronteggContext } from '@frontegg/rest-api';
import { AxiosAmbient } from 'src/lib';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';

export const getSummaryEvidenceForSelectedText = async (
  encounterId,
  selectedText,
  transcriptionType
) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };

    const data = {
      encounter_id: encounterId,
      selected_text: selectedText,
      transcription_type: transcriptionType,
    };

    const result = await AxiosAmbient.post(
      `/encounters/fetch_summary_evidence`,
      data,
      { headers }
    );
    const response = result.data;
    if (result?.status === 200) {
      showToastSuccess('Source found successfully');
      return response;
    }
  } catch (error) {
    showToastError('We could not find the relevant source. Please try again.');
    return null;
  }
};
